export const subscription = {
  subscriptions: 'Prenumerationer',
  plan: 'Plan',
  whatsappPlan: 'WhatsApp-plan',
  addOns: 'Tillägg',
  billingDetails: 'Faktureringsdetaljer',
  invoices: 'Fakturor',
  wa1Reminder: 'WA 1: a påminnelse',
  wa2Reminder: 'WA 2: a påminnelse',
  waRenewApi: 'WA Renew API',
  waCheckUsageApi: 'WA Check Usage API',
  waResetUsageApi: 'WA Reset Usage API',
  waExceedUsageApi: 'WA Exceed Usage API',
  waGetBotsInThisAccount: 'WA Get bots in this account',
  appTooltip: {
    TOOLTIP_PLAN_HEADING:
      'Vi har de mest överkomliga priserna för alla dina behov.',
    TOOLTIP_WHATSAPP_PLAN_HEADING: 'Whatsapp-plan',
    TOOLTIP_ADDS_ON_HEADING: 'Köp extra meddelandepaket och vitetiketterad bot',
    TOOLTIP_ADDS_ON_MESSAGE:
      'Om du har nått din månatliga meddelandelimit kan du köpa extra paket.',
    TOOLTIP_SUBSCRIPTION_HEADING:
      'Kontrollera dina nuvarande prenumerationsdetaljer',
    TOOLTIP_HORIZONTAL_BAR:
      'Kontrollera vår månatliga eller årliga prissättning från 3K till 500K meddelanden genom att flytta stången från vänster till höger.',
    TOOLTIP_BILLING_ADDRESS_HEADING:
      'Uppdatera dina faktureringsdetaljer för fakturering.',
    TOOLTIP_INVOICES_HEADING: 'Kontrollera dina tidigare fakturor.',
    TOOLTIP_INVOICES_ACTION: 'Klicka för att få fakturan i din e-post',
  },
  currentPlan: {
    seeHowToUse: 'Se hur du använder',
    help: 'Hjälp',
    downgradeRequest1: 'Du har begärt att sänka din plan till',
    downgradeRequest2:
      'meddelanden. Observera, Din plan kommer att sänkas i slutet av den nuvarande faktureringscykeln',
    downgradeRequest3: 'Du kan njuta av',
    downgradeRequest4: 'tjänster till dess.',
    downgradeRequestMaster1: 'Du har begärt att sänka din ',
    downgradeRequestMaster2: ' plan till',
    downgradeRequestMaster3:
      ' konversationer. Observera, Din plan kommer att sänkas i slutet av den nuvarande faktureringscykeln',
    downgradeRequestMaster4: 'Du kan njuta av ',
    downgradeRequestMaster5: 'tjänster till dess.',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    month: 'månad',
    year: 'år',
    messagePack: 'Meddelandepaket',
    king: 'King',
    baby: 'Baby',
    whatsapp: 'WhatsApp',
    youAreOn: 'Du är på',
    plan: 'plan',
    totalMessagesLimit: 'Totalt meddelandelimit',
    liveAgentLimit: 'Live Agent-begränsning',
    perMonth: '/månad',
    agents: 'agent(er)',
    messagesAddOn: 'Meddelande-tillägg',
    botWhitelabels: 'Bot Whitelabels',
    totalAddOnMessages: 'Totalt tillägg meddelanden',
    basePrice: 'Grundpris',
    gst: 'GST',
    totalPrice: 'Totalpris',
    totalAddOnPrice: 'Totalt tilläggspris',
    whitelabelPrice: 'Whitelabel pris',
    startedOn: 'Började den',
    nextDueOn: 'Nästa förfallodag',
    addOnExpiry: 'Add-on-förfall',
    website: 'Webbplats',
    facebook: 'Facebook',
    telegram: 'Telegram',
  },
  invoice: {
    invoiceNumber: 'Fakturanummer',
    date: 'Datum',
    invoiceAmount: 'Fakturabelopp',
    planAmount: 'Planbelopp',
    plan: 'Plan',
    messages: 'Meddelanden',
    action: 'Åtgärd',
    nA: 'NA',
    appTooltip: {
      clickToReceiveInvoiceInYourEmailAccount:
        'Klicka för att få fakturan i din e-post',
      clickToDownloadInvoice: 'Klicka för att ladda ner fakturan i PDF-form',
    },
  },
  messageAddOn: {
    validity: 'Giltighet',
    kingPlanHeader: '👑 King Plan',
    youAreOnThe: 'Du är på ',
    asOfNowAndWillGet: 'från och med nu och kommer att få ',
    messages: 'meddelanden ',
    inThisPlan: 'i denna plan. ',
    youCanBuyAdditionalMessaes:
      'Du kan köpa ytterligare meddelanden enligt dina affärsbehov.',
    plan: ' Plan',
    baby: 'Baby',
    king: 'King',
    get: 'Få ',
    babyPlan: 'Babyplan ',
    upgradePlan: 'Uppgradera plan',
    asOfNow: ' från och med nu.',
    pleaseUpgradeToKingPlan: 'Uppgradera till ',
    toEnableAddOnsAndWhitelabelPacks:
      ' för att aktivera Tillägg och Whitelabel-paket.',
    messageAddOnPacks: 'Meddelandetilläggspaket',
    ifYouHaveReachedYourMonthlyMessageLimit:
      'Om du har nått din månatliga meddelandelimit, köp ytterligare paket och njut av oavbrutna tjänster.',
    pleaseSelectNumberOfExpectedMessages:
      'Vänligen välj antalet förväntade meddelanden',
    addOnsValidity: 'Tilläggens giltighet',
    currentBillingCycle: 'Aktuell faktureringscykel',
    oneYear: 'Ett år',
    summary: 'Sammanfattning',
    messageCreditsWithKingPlan: 'meddelandekrediter med king plan',
    messageCreditsWith: 'meddelandekrediter med ',
    withPlan: '',
    billingCycle: 'Faktureringscykel',
    payableAmount: 'Betalbart belopp ',
    oneTimePayment: 'Engångsbetalning',
    plusTaxes: ' + Skatter',
    buyNow: 'Köp nu',
    whiteLabelChatWindow: 'White Label Chat-fönster',
    noBotsLeftToWhiteLabel: 'Inga bots kvar att Whitelabel.',
    pleaseSelectTheBotsYouWantToWhiteLabel:
      'Vänligen välj de bots du vill Whitelabel.',
    selectBots: 'Välj Bots',
    bot: 'Bot',
    bots: 'Bots',
    toBeWhiteLabelled: ' att vitetiketteras',
    remove: 'Ta bort ',
    brandNameFromChatWindow: ' varumärkesnamn från chattfönstret.',
    willBeValidTill: 'Kommer att vara giltigt till ',
    ourYearlyPrice: 'Vårt årliga pris ',
    directWhiteLabel: 'Direkt vitetikett',
    whiteLabelledBots: 'Vitetiketterade bots',
    nextRenewalColon: 'Nästa förnyelse: ',
    optOutRequested: 'Opt Out begärt',
    contactAgency: 'Kontakta byrån',
    optOut: 'Opt Out',
    removeWhiteLabel: 'Ta bort vit etikett',
    messageCount: 'Meddelanden',
    numberOfPacks: 'Antal paket',
    amount: 'Belopp',
    taxes: 'Skatter',
    totalAmount: 'Totalt belopp',
    numOfBots: 'Antal bots',
    select: 'Välj',
    selectTheValidity: 'Välj giltigheten',
  },
  payment: {},
  paymentMethod: {
    paymentDetails: 'Betalningsdetaljer',
    cardNumber: 'Kortnummer ',
    cvv: 'CVV ',
    // cardNumber: 'Card Number',
    month: 'Månad',
    year: 'År',
    save: 'Spara',
    add: 'Lägg till',
    edit: 'Redigera',
    disclaimer: 'Ansvarsfriskrivning: ',
    disclaimerDescription1:
      'Ovanstående betalningsmetoddetaljer gäller endast användare utanför Indien.',
    disclaimerDescription2:
      'Vi sparar inte dina kortuppgifter hos oss.' +
      'Om du vill ändra dina kortuppgifter ändras det direkt med betalningsgatewayen.',
    billingAddress: 'Faktureringsadress',
    companyName: 'Företagsnamn ',
    country: 'Land ',
    selectCountry: 'Välj land',
    stateOrRegion: 'Stat/Region ',
    streetAddress: 'Gatuadress ',
    gstIn: 'GSTIN ',
    postalCode: 'Postnummer ',
    cancel: 'Avbryt',
    proceedToPay: 'Fortsätt till betalning',
    company: 'Företag',
    state: 'Stat',
    masterCard: 'Master Card',
    yourCompanyName: 'Ditt företagsnamn',
    yourCountry: 'Ditt land',
    yourRegion: 'Din region',
    yourPostalCode: 'Ditt postnummer',
    plusTaxes: ' + skatter',
    dropDown: {
      month: 'Månad *',
      year: 'År *',
    },
    placeholders: {
      enterCardNumber: 'Ange kortnummer',
      cvv: 'CVV',
      enterYourCompanyName: 'Ange ditt företagsnamn',
      enterYourStateOrRegion: 'Ange din stat/region',
      enterYourStreetAddress: 'Ange din gatuadress',
      enterYourGSTIN: 'Ange din GSTIN',
      enterPostalCode: 'Ange postnummer',
    },
  },
  plans: {
    viewDetailedPricing: 'Visa detaljerad prissättning',
    seeHowToUse: 'Se hur du använder',
    help: 'Hjälp',
    weHaveGotAPricingPlanPerfectForYou:
      'Vi har ett prissättningsplan som är perfekt för dig',
    weBelieve: 'Vi tror att',
    shouldBeAccessibleToAllCompanies:
      ' borde vara tillgänglig för alla företag, oavsett storlek.',
    monthly: 'Månad',
    yearly: 'Årlig',
    twoMonthsFree: '(2 månader GRATIS)',
    babyPlan: 'Babyplan',
    freeForever: 'GRATIS för alltid',
    messagesPerMonth: 'Meddelanden per månad',
    currentPlan: 'Nuvarande plan',
    freePlan: 'GRATIS Plan',
    kingPlan: 'King Plan',
    perYear: 'per år',
    plan: 'plan',
    toThe: ' till',
    plusTaxes: ' + Skatter',
    perMonth: 'per månad',
    upgradePlan: 'Uppgradera plan',
    changePlan: 'Byt plan',
    currentlyActive: 'För närvarande aktiv',
    emperorPlan: 'Emperor Plan (Företag)',
    sendAsManyMessagesAsYouWant: 'Skicka så många meddelanden som du behöver',
    contactUs: 'Kontakta oss',
    features: 'Funktioner',
    areYouSureYouWantToShiftFrom: 'Är du säker på att du vill byta från',
    messages: 'Meddelanden',
    planQuestionMark: ' plan?',
    downgradeToFreePlan: 'Nedgradera till GRATIS Plan',
    goToBabyPlan: 'Gå till Babyplan',
    thankYouForChoosingBotPenguin: 'Tack för att du valde BotPenguin',
    bots: 'Bots',
    facebookPages: 'Facebook-sidor',
    teamMember: 'Teammedlem',
    dataStorage: 'Datlagring',
    conditionalFlow: 'Villkorlig flöde',
    liveChat: 'Livechatt',
    bookAppointments: 'Boka möten',
    csvExport: 'CSV-export',
    emailAndCallSupport: 'E-post och telefonsupport',
    googleCalendarIntegrations: 'Google Kalenderintegration',
    zohoCrmIntegrations: 'Zoho CRM-integration',
    reportsAndAnalytics: 'Rapporter och analyser',
    removeBotPenguinBranding: 'Ta bort BotPenguin-märkning',
    oneBot: '1 Bot',
    twoKMessagesPerMonth: '2 000 meddelanden/månad',
    oneFacebookPage: '1 Facebook-sida',
    oneTeamMember: '1 Teammedlem',
    thirtyDaysOfDataStorage: '30 dagar datalagring',
    unlimitedBot: 'Obegränsad Bot',
    threeTo500kMessagesPerMonth: '3 000 till 500 000 meddelanden/månad',
    tenFacebookPages: '10 Facebook-sidor',
    threeTeamMembers: '3 Teammedlemmar',
    nintyDaysOfDataStorage: '90 dagar datalagring',
    unlimitedMessages: 'Obegränsade meddelanden',
    unlimitedFacebookPages: 'Obegränsade Facebook-sidor',
    unlimitedTeamMembers: 'Obegränsade teammedlemmar',
    unlimitedDataStorage: 'Obegränsad datalagring',
    youAreHere: 'Du är här!',
    detailedPricing: {
      kingsplan: 'King Plan',
      elementary: 'Elementary',
      solutionType: 'Lösningstyp',
      saas: 'SaaS',
      fbpage1fb: '1 FB-sida',
      perMonth100: '100 per månad',
      enterprise: 'Företag',
      saasOnPremises: 'SaaS On Premises',
      aiChatbotFeatures: 'AI Chatbot-funktioner',
      dataSourceForTraning: 'Datakälla för träning',
      smartFeatures: 'Smart funktioner',
      liveChat: 'Live-chatt',
      day30: '30 dagar',
      day90: '90 dagar',
      landSquared: 'LandSquared',
      doItYourself: 'Gör det själv',
      unifiedInbox: 'Enhetlig inkorg',
      platforms: 'Plattformar',
      websiteChatbot: 'Webbplats Chatbot',
      FacebookMessengerChatbot: 'Facebook Messenger Chatbot',
      Telegram: 'Telegram',
      conversationalLandingPage: 'Konversationell landningssida',
      integrations: 'Integrationer',
      reportsAndAnalytics: 'Rapporter och analys',
      customerSupport: 'Kundsupport',
      security: 'Säkerhet',
      bots: 'Bots',
      babyPlan: 'Baby Plan',
      kingPlan: 'King Plan',
      emperorPlan: 'Emperor Plan',
      noofBots: 'Antal bots',
      one: '1 (En)',
      unlimitedBots: 'Obegränsade bots',
      noOfWebsite: 'Antal webbplatser',
      unlimitedWebsites: 'Obegränsade webbplatser',
      unlimitedMessages: 'Obegränsade meddelanden',
      messagesSend: 'Skickade meddelanden',
      perMonth2000: '2 000 per månad',
      upto500000perMonth: 'Upp till 500 000 per månad',
      facebookMessenger: 'Facebook Messenger',
      unlimitedPages: 'Obegränsade sidor',
      telegramNumbers: 'Telegram-nummer',
      unlimited: 'Obegränsat',
      whatsappNumbers: 'WhatsApp-nummer',
      subscribersLeads: 'Prenumeranter/Leads',
      createSupportTeam: 'Skapa supportteam för livechatt',
      oneMember: '1 Medlem',
      threeMembers: '3 medlemmar',
      conversationHistory: 'Samtalshistorik',
      thirtyDays: '30 dagar',
      ninetyDays: '90 dagar',
      chatbotDesigning: 'Chatbot-design',
      weAreHereToHelp: 'Vi är här för att hjälpa',
      weTakeCareEndToEnd: 'Vi tar hand om hela vägen',
      multipleLanguages: 'Flera språk',
      conditionalFlow: 'Villkorligt flöde',
      removeBotPenguinBranding: 'Ta bort BotPenguin-varumärket',
      gptMessages: 'GPT-meddelanden',
      aiChatbot: 'AI Chatbot',
      chatGPTIntegration: 'ChatGPT-integration',
      configureAIChatbotPersonality: 'Konfigurera AI Chatbot-personlighet',
      trainChatbotOnYourOwnData: 'Träna Chatbot på dina egna data',
      trainChatbotOnWebPages: 'Träna Chatbot på webbsidor',
      trainChatbotOnMultipleFiles: 'Träna Chatbot på flera filer',
      trainChatbotOnFAQs: 'Träna Chatbot på FAQs',
      dataTrainingStorage: 'Datalagringsutbildning',
      useChatGPTModel4_3_5Turbo: 'Använd ChatGPT-modell 4/3.5 turbo',
      uploadMultipleFilesForChatbotTraining:
        'Ladda upp flera filer för Chatbot-utbildning',
      naturalLanguageProcessing: 'Naturlig språkbehandling',
      naturalLanguageUnderstanding: 'Förståelse för naturligt språk',
      answerLength: 'Svarslängd',
      chatTone: 'Chattone',
      multiLanguage: 'Flera språk',
      answerFormatting: 'Svarformatering',
      customPrompt: 'Anpassad prompt',
      integrateBotPenguinLLM: 'Integrera BotPenguin LLM',
      integrateOwnCustomLLM: 'Integrera egen/anpassad LLM',
      periodicallySyncDataSources: 'Synka datakällor periodvis',
      aiBasedSuggestedQuestions: 'AI-baserade föreslagna frågor',
      chooseVisibilityForParticularWebpageSitemap:
        'Välj synlighet för särskild webbsida/sitemap',
      chooseKnowledgeMix:
        'Välj kunskapsmix:\nDin kunskapsbas\nChatGPT-kunskap\n"ChatGPT-kunskap + Din kunskapsbas"',
      faqExtractionFromFileAndURL: 'FAQ-extraktion från fil och URL',
      analyticsToImproveAI: 'Analys för att förbättra AI',
      exportQuestionFlow: 'Exportera frågeflöde',
      sessionManagement: 'Sessionshantering',
      collectFeedbackOnChatbotResponses: 'Samla feedback om Chatbot-svar',
      smartAIFollowUpQuestions: 'Smart/AI-uppföljningsfrågor',
      trainOnYourNotionWorkspaceData: 'Träna på dina Notion-arbetsplatsdata',
      trainOnYoutubeVideo: 'Träna på Youtube-video',
      trainOnCustomVideoUpload: 'Träna på anpassad videouppladdning',
      rssFeed: 'RSS-flöde',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      ipAndRegionBlocking: 'IP och regionblockering',
      emailAndMobileValidation: 'E-post och mobilvalidering',
      appointmentsBooking: 'Bokning av möten',
      humanHandover: 'Mänsklig överlämning',
      botHandover: 'Bot-överlämning',
      handoverBetweenAgents: 'Överlämning mellan agenter',
      mobileAppsForAgents: 'Mobilappar för agenter',
      roleBasedAccessControls: 'Rollbaserade åtkomstkontroller',
      apiIntegrationOnChatFlows: 'API-integration på chatflöden',
      liveChatWidget: 'Livechatt-widget',
      typingIndicator: 'Indikator för skrivning',
      liveVisitorsDetails: 'Livebesökares detaljer',
      multipleSimultaneousChat: 'Flera samtidiga chattar',
      liveTypingView: 'Live skrivvy',
      ruleBasedChatRouting: 'Regelbaserad chattvägledning',
      chatAutoAssignments: 'Chatt automatiska tilldelningar',
      efficientOmnichannelInterface: 'Effektiv omnichannel-gränssnitt',
      quickReplies: 'Snabbsvar',
      unifiedCustomerProfile: 'Enhetlig kundprofil',
      visitorStats: 'Besökarstatistik',
      addContactsFromWhatsapp: 'Lägg till kontakter från WhatsApp',
      applyFilterAndSortConversations: 'Använd filter och sortera samtal',
      seeChatLogs: 'Se chattloggar',
      assignNotesAndChatTags: 'Tilldela anteckningar och chattaggar',
      directCallsToLeadsWithTwilio: 'Direkta samtal till leads (med Twilio)',
      customerSegmentation: 'Kundsegmentering',
      exportLeadsInCSV: 'Exportera leads i CSV',
      leadNotificationsByEmail: 'Leadnotifikationer via e-post',
      website: 'Webbplats',
      wordPress: 'WordPress',
      whatsApp: 'WhatsApp',
      facebook: 'Facebook',
      telegram: 'Telegram',
      shopify: 'Shopify',
      autoTriggeringOnMobileDesktop: 'Automatisk utlösning på mobil/skrivbord',
      hideBotOnSpecificPages: 'Dölj bot på specifika sidor',
      imageSharing: 'Dela bilder',
      readyToUseChatFlowTemplates: 'Färdiga chattflödestemplates',
      fileSharing: 'Dela filer',
      customDesignForChatWindow: 'Anpassad design för chattfönster',
      facebookMessengerBot: 'Facebook Messenger Bot',
      facebookSubheading: 'facebooksubheading',
      telegramSubheading: 'telegramsubheading',
      conversationalLangdingPageSubheading:
        'Konversationslandningssida undertext',
      integrationsSubheading: 'Integrationer undertext',
      multipleSmartFlows: 'Flera smarta flöden',
      dripCampaigns: 'Droppkampanjer',
      broadcastFBMessages: 'Sänd FB-meddelanden',
      multipleFacebookBotWidgets: 'Flera Facebook-bot-widgets',
      facebookAutoReplyOnComments: 'Facebook Auto-Reply på kommentarer',
      facebookECommerce: 'Facebook E-handel',
      broadcastAnalytics: 'Sändningsanalys',
      telegramMessengerBot: 'Telegram Messenger Bot',
      readyToUseTemplates: 'Färdiga mallar',
      groupBroadcastTelegramMessages:
        'Grupp- och sändningsmeddelanden på Telegram',
      multipleTelegramBotWidgets: 'Flera Telegram-bot-widgets',
      conversationalLandingPageBot: 'Konversationslandningssida Bot',
      smartReplies: 'Smart svar',
      interactiveAndCustomizableUI:
        'Interaktivt och anpassningsbart användargränssnitt',
      leadManagement: 'Leadhantering',
      easyToInstallAndShare: 'Lätt att installera och dela',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'LeadSquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Stäng',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: 'Supportbiljettsystem',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: 'Ljud- och videosamtal i chatt (Twilio/Agora)',
      courierTracking: 'Fraktsedelsspårning',
      emailIntegration: 'E-postintegration',
      webhooks: 'Webhooks',
      schedulers: 'Schemaläggare',
      paymentGateways: 'Betalningsportar (Stripe & RazorPay)',
      enterpriseIntegrations: 'Företagsintegrationer',
      customIntegration: 'Anpassad integration',
      shopifyIntegration: 'Shopify-integration',
      totalNumberOfMessages: 'Totalt antal meddelanden',
      totalNumberOfLeads: 'Totalt antal leads',
      weeklyReportBotwise: 'Veckorapport, botvist',
      averageAgentResponeTime: 'Genomsnittlig svarstid för agenter',
      visitorTimingReport: 'Besökstidrapport',
      customerSegmentBasedReports: 'Rapporter baserade på kundsegment',
      tagBasedReports: 'Taggbaserade rapporter',
      leadGenerationReport: 'Leadgenereringsrapport',
      supportOnWhatsApp: 'Support på WhatsApp',
      knowledgeBase: 'Kunskapsbas',
      onboardingAndTraining: 'Onboarding och träning',
      callAndEmailSupport: 'Support via samtal och e-post',
      freeChatbotCreation: 'Gratis chattbot-skapande',
      customerSuccessOfficer: 'Kundframgångsofficer',
      secureConnection2048BitSSL: 'Säker anslutning 2048-bitars SSL',
      securityAssessment: 'Säkerhetsbedömning',
      dataCenterInUSOrEU: 'Datacenter i USA eller EU',
      twoStepVerification: 'Tvåstegsverifiering',
      accessRestrictionsBasedOnIPs:
        'Åtkomstbegränsningar baserade på IP-adresser',
      onDemandAuditLog: 'På begäran granskningslogg',
      bannedVisitorsList: 'Lista över förbjudna besökare',
      customAPIRate: 'Anpassad API-hastighet',
      trustedDomains: 'Pålitliga domäner',
      mb100: '100 MB',
      gb1: '1 GB',
      codingCurious: 'Kodintresserad',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: 'Vårt gratispaket',
      TOOLTIP_KING_PLAN: 'Vårt mest populära paket',
      TOOLTIP_EMPEROR_PLAN:
        'Anpassat paket för obegränsade meddelanden, obegränsad data, obegränsade teammedlemmar',
      TOOLTIP_CONTACT_US:
        'Kontakta oss via WhatsApp eller e-post på contact@botpenguin.com ' +
        'för att lära dig mer om vårt anpassade paket',
      TOOLTIP_UPGRADE:
        'Uppgradera ditt nuvarande paket för ytterligare funktioner',
      TOOLTIP_MONTHLY: 'Välj en månatlig betalningscykel',
      TOOLTIP_YEARLY: 'Välj en årlig betalningscykel för rabattfördelar',
    },
  },
  whatsappPlans: {
    goToBabyPlan: 'Gå till Baby Plan',
    freeForever: 'GRATIS för alltid',
    features: 'Funktioner',
    currentPlan: 'Nuvarande plan',
    changePlan: 'Byt plan',
    currentlyActive: 'För närvarande aktiv',
    seeHowToUse: 'Se hur du använder',
    weHaveGotPricingPerfectForYou: `Vi har ett prissättningsplan som är perfekt för dig`,
    weBelieve: 'Vi tror att ',
    shouldBeAccessibleToAllCompanies:
      ' borde vara tillgänglig för alla företag, oavsett storlek.',
    monthly: 'Månadsvis',
    yearly: 'Årlig',
    twoMonthsFree: '(2 månader GRATIS)',
    kingPlan: 'King Plan',
    perYear: 'per år',
    perMonth: 'per månad',
    conversationsPerMonth: 'Samtal per månad',
    upgradePlan: 'Uppgraderingsplan',
    emperorPlan: 'Emperor Plan (Enterprise)',
    haveAsManyConversationsAsYouNeed:
      'Ha så många konversationer som du behöver',
    contactUs: 'Kontakta oss',
    metaConversationChargesAreAdditional:
      'Meta-konversationsavgifter är extra och betalas direkt av dig till Meta, baserat på' +
      'din användning. Vi tar inte ut någon pålägg eller underlättande avgifter.',
    viewDetailedPricing: 'Visa detaljerad prissättning',
    conversationPricingModelUsedByMeta:
      'Konversationsprismodell som används av Meta',
    whatsappBusinessPlatformConversationsFallInto:
      'WhatsApp Business Platform-konversationer delas in i två kategorier som prissätts olika',
    userInitiatedConversation: 'Användarinitierad konversation',
    userInitiatedConversationDescription:
      'En konversation som startar som svar på ett användarmeddelande. När ett företag svarar på en användare inom' +
      '24 timmars kundservicefönster kommer det meddelandet att associeras med en användarinitierad konversation.' +
      'Företag kan skicka meddelanden fritt inom detta 24-timmars kundservicefönster.',
    businessInitiatedConversation: 'Företagsinitierad konversation',
    businessInitiatedConversationDescription:
      'En konversation som startar från ett företag som skickar ett meddelande till en användare utanför 24-timmars' +
      'kundservicefönstret. Meddelanden som initierar en företagsinitierad konversation kräver en meddelandemall.',
    areYouSureYouWantTo: 'Är du säker på att du vill byta från',
    conversations: ' Konversationer ',
    plan: ' plan',
    toThe: ' till ',
    metaPricingMarkup: 'Meta Pricing Markup',
    numberOfChatFlows: 'Antal chattflöden',
    greenTickApplication: 'Ansökan om grönt kryss',
    extraPhoneNumberLinking: 'Extra telefonnummerlänkning',
    teamMembers: 'Teammedlemmar',
    dataStorage: 'Datlagring',
    conditionalFlow: 'Villkorligt flöde',
    liveChat: 'Live Chat',
    smartInbox: 'Smart Inkorg',
    whatsappTemplates: 'WhatsApp-mallar',
    customerSegments: 'Kundsegment',
    broadcastAndDripCampaigns: 'Sändnings- och droppkampanjer',
    multipleLanguages: 'Flera språk',
    bookAppointments: 'Boka möten',
    csvContactsExport: 'CSV-kontakter Export',
    googleCalendarIntegrations: 'Google Kalender Integrationer',
    nativeApplications: '60+ Nativ integration',
    whatsappSupport: 'WhatsApp-support',
    emailAndCallSupport: 'E-post- och samtalsstöd',
    customerIntegrations: 'Kundintegrationer',
    nlpAndNluCapabilities: 'NLP och NLU-funktioner',
    chatGPTBot: 'ChatGPT-chatbot',
    customerSuccessOfficer: 'Kundframgångsofficer',
    noMarkupTransparency: 'Ingen markup-transparens',
    upto500kPerMonth: 'Upp till 500 000 per månad',
    beyond500k: 'Över 500 000',
    unlimited: 'Obegränsad',
    unlimitedMessages: 'Obegränsade meddelanden',
    oneTeamMember: '1 Teammedlem',
    unlimitedTeamMember: 'Obegränsade Teammedlemmar',
    nintyDaysOfDataStorage: '90 dagar datalagring',
    unlimitedDataStorage: 'Obegränsad datalagring',
    downgradeToFreePlan: 'Degradera till GRATIS plan',
    detailedPricing: {
      onDemandAuditLog: 'På begäran granskningslogg',
      accessRestrictionsBasedOnIPs:
        'Åtkomstbegränsningar baserade på IP-adresser',
      averageAgentResponeTime: 'Genomsnittlig svarstid för agent',
      perMonth100: '100 per månad',
      solutionType: 'Lösningstyp',
      saas: 'SaaS',
      saasOnPremises: 'SaaS On Premises',
      emperorPlan: 'Emperor Plan',
      babyPlan: 'Baby Plan',
      kingsplan: 'Kings Plan',
      braodcastsAndDrips: 'Sändningar och Droppar',
      thirtyDays: '30 dagar',
      ninetyDays: '90 dagar',
      oneMember: '1 Medlem',
      threeMembers: '3 medlemmar',
      one: '1 (En)',
      unlimitedMessages: 'Obegränsade meddelanden',
      unlimitedBots: 'Obegränsade Bots',
      messagesSend: 'Skickade meddelanden',
      upto500000perMonth: 'Upp till 500 000 per månad',
      unlimited: 'Obegränsad',
      onlyAdmin: 'Endast admin',
      mb100: '100 MB',
      gb1: '1 GB',
      doItYourself: 'Gör det själv',
      weAreHereToHelp: 'Vi är här för att hjälpa',
      weTakeCareEndToEnd: 'Vi tar hand om från början till slut',
      numberOfBots: 'Antal bots',
      conversations: 'Samtal',
      gptMessages: 'GPT-meddelanden',
      whatsappNumbers: 'WhatsApp-nummer',
      subscribersLeads: 'Prenumeranter/Leads',
      createSupportTeamForLiveChat: 'Skapa supportteam för live-chatt',
      conversationHistory: 'Konversationshistorik',
      chatbotDesigning: 'Chattbotdesign',
      multipleLanguages: 'Flera språk',
      conditionalFlow: 'Villkorligt flöde',
      whatsappTemplates: 'WhatsApp-mallar',
      restartChatFlowTriggers: 'Starta om Chattflödesutlösare',
      multipleWhatsAppWidgets: 'Flera WhatsApp-widgets',
      importWhatsappContacts: 'Importera WhatsApp-kontakter',
      whatsappQuickReply: 'WhatsApp Snabbsvar',
      whatsappSmartInbox: 'WhatsApp Smart Inkorg',
      whatsappEcommerceCatalogs: 'WhatsApp E-handel med Kataloger',
      whatsappBroadcast: 'WhatsApp-sändning',
      whatsappBroadcastAnalytics: 'WhatsApp Broadcast Analytics',
      dripCampaigns: 'Droppkampanjer',
      customerSegmentation: 'Kundsegmentering',
      keywordBasedResponse: 'Svar baserat på nyckelord',
      whatsappShopManagement: 'WhatsApp Shop Management',
      aiChatbot: 'AI Chatbot',
      chatGPTIntegration: 'ChatGPT Integration',
      configureAIChatbotPersonality: 'Konfigurera AI Chatbot-personlighet',
      trainChatbotOnYourOwnData: 'Träna Chatbot på din egen data',
      trainChatbotOnWebPages: 'Träna Chatbot på webbsidor',
      trainChatbotOnMultipleFiles: 'Träna Chatbot på flera filer',
      trainChatbotOnFAQs: 'Träna Chatbot på FAQs',
      dataTrainingStorage: 'Dataträningslagring',
      useChatGPTModel4or35Turbo: 'Använd ChatGPT Model 4/3.5 turbo',
      uploadMultipleFilesForChatbotTraining:
        'Ladda upp flera filer för chattbotträning',
      naturalLanguageProcessing: 'Naturlig språkbehandling',
      naturalLanguageUnderstanding: 'Förståelse för naturligt språk',
      answerLength: 'Svarslängd',
      chatTone: 'Chatt ton',
      multiLanguage: 'Flera språk',
      answerFormatting: 'Svarformatering',
      customPrompt: 'Anpassad Prompt',
      whatsAppSessionManagement:
        'WhatsApp Session Management (Inaktivitet och Flödesomstartmeddelanden)',
      integrateBotPenguinLLM: 'Integrera BotPenguin LLM',
      integrateOwnCustomLLM: 'Integrera egen/anpassad LLM',
      periodicallySyncDataSources: 'Synkronisera periodvis datakällor',
      aiBasedSuggestedQuestions: 'AI-baserade föreslagna frågor',
      chooseVisibilityForParticularWebpageSitemap:
        'Välj synlighet för en särskild webbsida/sitemap',
      chooseKnowledgeMix:
        'Välj Kunskapsmix: Din kunskapsbas ChatGPT-kunskap "ChatGPT-kunskap + Din kunskapsbas"',
      faqExtractionFromFileAndURL: 'FAQ-extraktion från fil och URL',
      analyticsToImproveAI: 'Analys för att förbättra AI',
      exportQuestionFlow: 'Exportera Frågeflöde',
      collectFeedbackOnChatbotResponses: 'Samla feedback på Chatbot-svar',
      smartAIFollowUpQuestions: 'Smart/AI Uppföljningsfrågor',
      trainOnYourNotionWorkspaceData: 'Träna på din Notion-arbetsytdsdata',
      trainOnYoutubeVideo: 'Träna på Youtube-video',
      trainOnCustomVideoUpload: 'Träna på anpassad videouppladdning',
      rssFeed: 'RSS-flöde',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      humanHandover: 'Mänsklig överlämning',
      botHandover: 'Bot-överlämning',
      handoverBetweenAgents: 'Överlämning mellan agenter',
      emailAndMobileValidation: 'E-post- och mobilvalidering',
      mobileAppsForAgents: 'Mobilappar för agenter',
      appointmentBooking: 'Bokning av möten',
      roleBasedAccessControls: 'Rollbaserade åtkomstkontroller',
      ruleBasedChatRouting: 'Regelbaserad chattmottagning',
      liveVisitorsDetails: 'Live Besökares detaljer',
      multipleSimultaneousChats: 'Flera samtidiga chattar',
      visitorStats: 'Besökarstatistik',
      addContactsFromWhatsApp: 'Lägg till kontakter från WhatsApp',
      applyFilterAndSortConversations: 'Tillämpa filter och sortera samtal',
      seeChatLogs: 'Se chattloggar',
      quickReplies: 'Snabba svar',
      unifiedCustomerProfile: 'Enhetlig kundprofil',
      assignNotesAndChatTags: 'Tilldela anteckningar och chattaggar',
      exportLeadsInCSV: 'Exportera Leads i CSV',
      tagContacts: 'Tagga kontakter',
      customAttributes: 'Anpassade attribut',
      markStatusOfConversations: 'Markera status för konversationer',
      assignConversationToAgents: 'Tilldela konversation till agenter',
      leadNotificationsByEmail: 'Leadnotiser via e-post',
      directCallsToLeadsWithTwilio: 'Direkta samtal till leads (med Twilio)',
      whatsAppTemplates: 'WhatsApp-mallar',
      promotionalMessageFrequencyControl:
        'Kontroll av frekvens för reklammeddelanden',
      whatsAppWidget: 'WhatsApp Widget',
      whatsAppQR: 'WhatsApp QR',
      whatsAppLink: 'WhatsApp-länk',
      campaignScheduler: 'Kampanjschemaläggare',
      customTriggers: 'Anpassade triggare',
      customCampaigns: 'Anpassade kampanjer',
      repeatPurchaseReminders: 'Påminnelser om återköp',
      campaignOpenRateTracking: 'Spårning av kampanjöppningsfrekvens',
      paymentCollectionOnWhatsApp: 'Betalningsinsamling på WhatsApp',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'Leadsquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Stäng',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: 'Support Ticketing System',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: 'In-chat audio and video call (Twilio/Agora)',
      courierTracking: 'Courier Tracking',
      emailIntegration: 'Email Integration',
      webhooks: 'Webhooks',
      schedulers: 'Schedulers',
      paymentGateways: 'Payment Gateways (Stripe & RazorPay)',
      enterpriseIntegrations: 'Enterprise Integrations',
      customIntegration: 'Custom Integration',
      freeWhatsAppAPIApprovalAndSetup: 'Free WhatsApp API approval and setup',
      developerAPIsAccess: 'Developer APIs access',
      customRateLimit: 'Custom Rate Limit',
      totalNumberOfLeads: 'Totalt antal leads',
      averageAgentResponseTime: 'Genomsnittlig svarstid för agent',
      visitorTimingReport: 'Besökares tidsrapport',
      customerSegmentBasedReports: 'Rapporter baserade på kundsegment',
      tagBasedReports: 'Rapporter baserade på taggar',
      leadGenerationReport: 'Leadgenereringsrapport',
      supportOnWhatsApp: 'Support på WhatsApp',
      knowledgeBase: 'Kunskapsbas',
      onboardingAndTraining: 'Onboarding och träning',
      callAndEmailSupport: 'Support via samtal och e-post',
      freeChatbotCreation: 'GRATIS skapande av chatbot',
      customerSuccessOfficer: 'Kundframgångsmedarbetare',
      secureConnection: '2048-bitars SSL-säker anslutning',
      securityAssessment: 'Säkerhetsbedömning',
      dataCenterLocation: 'Datacenter i USA eller EU',
      twoStepVerification: '2-stegsverifiering',
      accessRestrictions: 'Åtkomstbegränsningar baserade på IP-adresser',
      auditLog: 'På begäran revisionslogg',
      bannedVisitorsList: 'Lista över blockerade besökare',
      customAPIRate: 'Anpassad API-takt',
      trustedDomains: 'Pålitliga domäner',
      elementary: 'Elementär',
      bots: 'Bots',
      unlockWhatsapp: 'Lås upp WhatsApp',
      aiChatbotFeatures: 'AI Chatbot-funktioner',
      dataSourceForTraining: 'Datakälla för träning',
      smartFeatures: 'Smarta funktioner',
      liveChat: 'Live-chatt',
      smartInbox: 'Smart inkorg',
      broadcastsAndDrips: 'Sändningar och droppar',
      integrations: 'Integrationer',
      development: 'Utveckling',
      reportsAndAnalytics: 'Rapporter och analyser',
      customerSupport: 'Kundsupport',
      security: 'Säkerhet',
      whatsappWidgets: 'WhatsApp-widgets',
      campaignSchedular: 'Kampanjplanerare',
      repeatPurchaseRemainder: 'Påminnelse om återköp',
      // metaConversationChargesAreAdditional: 'Meta conversation charges are additional and paid directly by you to Meta, based on' +
      //   ' your usage. We do not charge any markup or facilitation fees.',
      // kingPlan: 'King Plan',
      // emperorPlan: 'Emperor Plan',
      // solutionType: 'Solution Type',
      // whatsappTemplates: 'WhatsApp Templates',
      // dripCampaigns: 'Drip campaigns',
      // multipleWhatsappWidgets: 'Multiple WhatsApp Widgets',
      // importWhatsappContacts: 'Import Whatsapp Contacts',
      // whatsappQuickReply: 'WhatsApp Quick reply',
      // whatsappSmartInbox: 'WhatsApp Smart Inbox',
      // whatsappECommerceWithCatalogs: 'WhatsApp E-commerce with Catalogs',
      // whatsappBroadcast: 'WhatsApp Broadcast',
      // whatsappBroadcastAnalytics: 'WhatsApp Broadcast Analytics',
      // customerSegmentation: 'Customer Grouping',
      // keywordBasedResponse: 'Keyword Based Response',
      // nlpBasedTraining: 'NLP Based Training',
      // humanHandOver: 'Human Handover',
      // botHandOver: 'Bot Handover',
      // handOverBetweenAgents: 'Handover between Agents',
      // emailAndMobileValidation: 'Email and Mobile Validation',
      // mobileAppsForAgents: 'Mobile Apps for Agents',
      // appointmentsBooking: 'Appointments Booking',
      // chatGPTIntegration: 'ChatGPT integration',
      // faqTraining: 'FAQ Training',
      // naturalLanguageProcessing: 'Natural Language Processing',
      // naturalLanguageUnderstanding: 'Natural Language Understanding',
      // roleBasedAccessControl: 'Role-based Access Controls',
      // liveVisitorsDetails: 'Live Visitors details',
      // multipleSimultaneousChats: 'Multiple simultanaeous chats',
      // ruleBasedChatRouting: 'Rule based Chat Routing',
      // createSupportTeamForLiveChat: 'Create Support Team for Live chat',
      // visitorStats: 'Visitor stats',
      // addContactsFromWhatsapp: 'Add Contacts from Whatsapp',
      // applyFilterAndSortConversation: 'Apply filter and sort conversations',
      // seeChatLogos: 'See chat logs',
      // directCallToLeads: 'Direct Calls-to-leads (with Twilio)',
      // quickReplies: 'Quick Replies',
      // unifiedCustomerProfile: 'Unified Customer Profile',
      // assignNotesAndChatTags: 'Assign Notes and Chat Tags',
      // exportLeadsInCsv: 'Export Leads in CSV',
      // leadNotificationsByEmail: 'Lead Notifications by email',
      // promotionalMessageFrequencyControl: 'Promotional Message Frequency Control',
      // repeatPurchaseRemainder: 'Repeat Purchase Reminders',
      // whatsappWidgets: 'WhatsApp Widget',
      // whatsappQR: 'WhatsApp QR',
      // whatsappLink: 'WhatsApp Link',
      // campaignSchedular: 'Campaign Scheduler',
      // campaignOpenRateTracking: 'Campaign Open Rate Tracking',
      // customTriggers: 'Custom Triggers',
      // customCampaigns: 'Custom Campaigns',
      // paymentCollectionOnWhatsapp: 'Payment Collection On WhatsApp',
      // zapier: 'Zapier',
      // crmIntegrations: 'CRM Integrations (25+)',
      // supportTicketingSystem: 'Support Ticketing System',
      // googleSheets: 'Google Sheets',
      // inChatAudioAndVideo: 'In-chat audio and video call',
      // googleCalendar: 'Google Calendar',
      // googleAnalytics: 'Google Analytics',
      // emailIntegration: 'Email Integration',
      // courierTracking: 'Courier Tracking',
      // webhooks: 'Webhooks',
      // paymentGateways: 'Payment Gateways',
      // hubspot: 'HubSpot ',
      // gitHub: 'GitHub ',
      // zendesk: 'Zendesk',
      // salesforce: 'Salesforce',
      // customIntegrations: 'Custom Integrations',
      // developerApisAccess: 'Developer APIs access',
      // customRateLimit: 'Custom Rate Limit ',
      // totalNumberOfLeads: 'Total Number of Leads',
      // averageAgentResponseTime: 'Average agent respone time',
      // visitorTimingReport: 'Visitor Timing Report',
      // customerSemgentBasedReport: 'Customer Group-based Reports',
      // tagBasedReport: 'Tag-based Reports',
      // leadGenerationReport: 'Lead Generation Report',
      // supportOnWhatsapp: 'Support on WhatsApp',
      // knowledgeBase: 'Knowledge Base',
      // onboardingAndTraining: 'Onboarding and Training',
      // callAndEmailSupport: 'Call and Email Support',
      // freeChatBotCreation: 'FREE chatbot creation',
      // elementary: 'Elementary',
      // smartFeatures: 'Smart Features',
      // liveChat: 'Live Chat',
      // smartInbox: 'Smart Inbox',
      // broadcastsAndDrips: 'Broadcasts & Drips',
      // integrations: 'Integrations',
      // development: 'Development',
      // reportsAndAnalytics: 'Reports and Analytics',
      // customerSupport: 'Customer Support',
      // unlockWhatsapp: 'Unlock WhatsApp',
      // saas: 'SaaS',
      // saasOnPremises: 'SaaS/On-Premises',
      // customerFaqs: `Custom FAQ's`,
      // oneMember: '1 member',
      // beWhereTheCustomersAre: 'Be where the customers are',
      // lifesEasy: 'Life\'s easy',
      // oneTextAway: 'One text away',
      // everyWhereAtOnce: 'Everywhere at Once',
      // reachOut: 'Reach Out',
      // morePowerToYou: 'More power to you',
      // codingCurious: 'Coding Curious',
      // knowledgeIsPower: 'Knowledge is power',
      // noDoubtsRemain: 'No doubts remain',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: 'Vårt gratisplan',
      TOOLTIP_KING_PLAN: 'Vårt mest populära plan',
      TOOLTIP_EMPEROR_PLAN:
        'Anpassat plan för obegränsade meddelanden, obegränsad data, obegränsade teammedlemmar',
      TOOLTIP_CONTACT_US:
        'Kontakta oss via WhatsApp eller e-post på contact@botpenguin.com för att få veta mer om vårt anpassade plan',
      TOOLTIP_UPGRADE:
        'Uppgradera ditt nuvarande plan för ytterligare funktioner',
      TOOLTIP_MONTHLY: 'Välj en månatlig betalningscykel',
      TOOLTIP_YEARLY: 'Välj en årlig betalningscykel för rabattförmåner',
    },
  },
};
